/* global jQuery */
// https://gist.github.com/njam/7974250

(function ($) {
  function visible (element) {
    return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function () {
      return $.css(this, 'visibility') === 'hidden'
    }).length
  }

  function focusable (element, isTabIndexNotNaN) {
    var map; var mapName; var img; var nodeName = element.nodeName.toLowerCase()
    if (nodeName === 'area') {
      map = element.parentNode
      mapName = map.name
      if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
        return false
      }
      img = $('img[usemap=#' + mapName + ']')[0]
      return !!img && visible(img)
    }
    return (/input|select|textarea|button|object/.test(nodeName)
      ? !element.disabled
      : nodeName === 'a'
        ? element.href || isTabIndexNotNaN
        : isTabIndexNotNaN) &&
          // the element and all of its ancestors must be visible
          visible(element)
  }

  $.extend($.expr[':'], {
    focusable: function (element) {
      return focusable(element, !isNaN($.attr(element, 'tabindex')))
    }
  })
})(jQuery)

function a11yAccordionRemoveTabIndex ($context) {
  if (typeof $context === 'undefined') {
    $context = $('body')
  }
  $context.find('[data-aria-accordion-panel][aria-hidden="true"]').each(function (index, element) {
    const $panel = $(element)

    $panel.attr('tabindex', -1)
    $panel.find(':focusable').attr('tabindex', -1)
  })
}

$(document).on('click', '.accordion__trigger', function (e) {
  const $button = $(e.currentTarget)

  const $parentHeading = $button.closest('[data-aria-accordion-heading]')
  const $panel = $parentHeading.next('[data-aria-accordion-panel]')

  if ($button.attr('aria-expanded') === 'true') {
    $panel.removeAttr('tabindex', '')
    $panel.find(':focusable').removeAttr('tabindex')
  } else {
    $panel.attr('tabindex', -1)
    $panel.find(':focusable').attr('tabindex', -1)
  }
})

$(document).on('a11y:refresh_accordion', function (e, $context) {
  a11yAccordionRemoveTabIndex($context)
})
a11yAccordionRemoveTabIndex()
